import { useMediaQuery } from 'usehooks-ts';

import { breakpoints } from '~/constants';

export function useIsMobile(): boolean {
  return useMediaQuery(`(width < ${breakpoints.sm})`);
}

export function useIsTablet(): boolean {
  return useMediaQuery(
    `(width >= ${breakpoints.sm}) and (width < ${breakpoints.lg})`,
  );
}

export function useIsDesktop(): boolean {
  return useMediaQuery(
    `(width >= ${breakpoints.lg}) and (width < ${breakpoints.xl})`,
  );
}

export function useIsLargeDesktop(): boolean {
  return useMediaQuery(`(width >= ${breakpoints.xl})`);
}
